module.exports = __webpack_public_path__ + "static/snippetsVScode-37ca5005e4525aa6e35bab19b8cbda3e.png";